module.exports = "/assets/c5f6035b0e383c83e43495f3ff046cf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/K2.png
// module id = 1530
// module chunks = 0